/* This file is autogenerated, see readme.md for instructions */
import ParagraphCenterAlignSvgIcon from '@bloomreach/banana-theme/icons/paragraph-center-align.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ParagraphCenterAlignIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ParagraphCenterAlignSvgIcon />
    </Icon>
  );
});

ParagraphCenterAlignIcon.displayName = 'ParagraphCenterAlignIcon';

export default ParagraphCenterAlignIcon;
